import {
  AnotherRegister,
  CheckboxWrapper,
  Column,
  Container,
  Row,
  Title
} from "./styles";

//components

import Input from 'components/Input'
import Buttons from 'components/Buttons'
import AuthHeader from '../Header'

//icons

import LockIcon from 'components/StaticIcons/Lock'
import Logo from 'components/StaticIcons/Logo'
import MailIcon from 'components/StaticIcons/Mail'
import { Link, useNavigate } from 'react-router-dom'
import { Controller } from "react-hook-form";
import Form from "components/Form/Form";
import Checkbox from "components/Checkbox";

interface Props {
  title: string;
  control: any;
  bottomText: string;
  bottomLink: string;
  formParams: any;
}

export default function PageTemplate({ title, control, bottomText, bottomLink, formParams }: Props) {

  const navigate = useNavigate()

  function setProps(onChange: any, name: string, value: any) {
    return { onChange, name, value }
  }

  return (
    <>
      <AuthHeader />
      <Container>
        <Column bottom="2.4rem">
          <Logo width="6.8rem" height="6.8rem" />
          <Title>{title}</Title>
        </Column>
        <Form>
          <Column>
            <Controller
              control={control}
              name="email"
              render={({
                field: { value, name, onChange }
              }) => (
                <Input
                  {...setProps(onChange, name, value)}
                  placeholder="E-mail"
                  leftElement={<MailIcon />}
                  hasLeftIcon
                />
              )}
            />
            <Controller
              control={control}
              name="password"
              render={({
                field: { value, name, onChange },
              }) => (
                <Input
                  {...setProps(onChange, name, value)}
                  placeholder="Password"
                  leftElement={<LockIcon />}
                  hasLeftIcon
                />
              )}
            />
          </Column>
          <Row bottom=".8rem">
            {title === "Sign up" ?
              <Controller
                control={control}
                name="agree"
                render={({
                  field: { value, name, onChange },
                }) => (
                  <CheckboxWrapper top="1.2rem" bottom="1.6rem">
                    <Checkbox
                      isActive={value}
                      name={name}
                      onChange={onChange}
                      label="I agree to the terms and conditions and the privacy policy"
                    />
                  </CheckboxWrapper>
                )}
              /> :
              <Link to="/auth/recovery">
                Forgot password?
              </Link>
            }
          </Row>
          <Buttons variable='solid' height="big" onClick={(event: any) => event.preventDefault()}>
            {title}
          </Buttons>
        </Form>
        <AnotherRegister>
          {bottomText}
          {/* <Link to={bottomLink}> */}
            <Buttons variable="outline" height="small" onClick={() => navigate(bottomLink)}>
              {title === "Sign in" ? "Sign up" : "Sign in"}
            </Buttons>
          {/* </Link> */}
        </AnotherRegister>
      </Container>
    </>
  )
}
